import React from "react";
import style from './FooterSec.module.css';
import Coat from './../../assets/images/gerb.svg';
import Copyright from './../../assets/images/copyright-regular.svg'
import NorkLogo from "../../assets/images/NorkLogo.png";
import MlsaIcon from "../../assets/images/MLSA_icon_yellow_72ppi.png";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

export default function FooterSec() {
    const  { t } = useTranslation();

    return (
        <>
            <div className={style.footerSec}>
                <div className={style.coat}>
                    <img src={Coat} alt=""/>
                    <img src={MlsaIcon} alt="" />
                </div>
                <div className={style.footerText}>
                    <div style={{display: 'flex', gap: 10}}>
                        <img src={Copyright} alt=""/>
                        <p> {new Date().getFullYear()} {t('title')}</p>
                    </div>
                </div>
            </div>
            <div className={style.FootBlockPrivacy}>
                <a href={'https://nork.am/'}>
                    <img src={NorkLogo} alt=""/>
                    <span>{t('nork')} {new Date().getFullYear()}</span>
                </a>
            </div>
            <div className={style.otherPages}>
                <Link to="/processing-personal-datas" >{t('ProcessingPersonalDatas')}</Link>
                <span>|</span>
                <Link to="/availability-statements" >{t('AvailabilityStatements')}</Link>
            </div>
        </>
    )
}